import { WithPopover, Wrapper } from '@american-autonomy/ag-ui';

import DropdownMenuItemContainer from 'components/DropdownMenuItemContainer';
import BodyText from 'components/text/BodyText';

import useExportKml from './hooks/useExportKml';
import useExportPdf from './hooks/useExportPdf';
import useTranslation from './hooks/useTranslation';

import ExportDropdownTrigger from './components/ExportDropdownTrigger';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ExportDropdown: FunctionComponent<Props> = ({
    className = '',
    selectedFlights = [],
    testId = TEST_ID
}) => {
    const { EXPORT_KML, EXPORT_PDF } = useTranslation();
    const { handleExportKml } = useExportKml({ selectedFlights });
    const { handleExportPdf } = useExportPdf({ selectedFlights });

    const isDisabled = selectedFlights.length === 0;

    if (isDisabled) {
        return (
            <Wrapper className={`${className} ${styles.exportDropdown}`} testId={testId}>
                <ExportDropdownTrigger isDisabled />
            </Wrapper>
        );
    }

    return (
        <WithPopover
            className={`${className} ${styles.exportDropdown}`}
            direction='bottomLeft'
            testId={testId}
            trigger={<ExportDropdownTrigger />}>
            <Wrapper className={styles.menu}>
                <DropdownMenuItemContainer onClick={handleExportPdf}>
                    <BodyText className={styles.menuItemText} text={EXPORT_PDF} />
                </DropdownMenuItemContainer>

                <DropdownMenuItemContainer onClick={handleExportKml}>
                    <BodyText className={styles.menuItemText} text={EXPORT_KML} />
                </DropdownMenuItemContainer>
            </Wrapper>
        </WithPopover>
    );
};

export default ExportDropdown;
